import { atom } from 'jotai';

export const isKnowledgeBaseOpenAtom = atom<boolean>(false);
